module.exports = {
    shop: {
        lang: {
            ru: {
                type: {
                    '1': {
                        mainMenuTitles: {
                            0: 'Сценарий',
                            1: 'События',
                            2: 'Рассылки',
                            3: 'Клиенты',
                            4: 'Модули',
                            5: 'Переменные',
                            6: 'Заказы',
                            7: 'Каталог товаров',
                            8: 'Доставка',
                            9: 'Промокоды',
                            10: 'Карточка',
                            11: 'Посты',
                            12: 'Переходы',
                            13: 'Статистика',
                            14: 'Инструменты',
                            15: 'Мессенджер'
                        }
                    },
                    '2': {
                        mainMenuTitles: {
                            0: 'Сценарий',
                            1: 'События',
                            2: 'Рассылки',
                            3: 'Клиенты',
                            4: 'Модули',
                            5: 'Переменные',
                            6: 'Заказы',
                            7: 'Каталог товаров',
                            8: 'Адресы моек',
                            9: 'Промокоды',
                            10: 'Карточка',
                            11: 'Посты',
                            12: 'Переходы',
                            13: 'Статистика',
                            14: 'Инструменты',
                            15: 'Мессенджер'
                        }
                    },
                    '3': {
                        mainMenuTitles: {
                            0: 'Сценарий',
                            1: 'События',
                            2: 'Рассылки',
                            3: 'Клиенты',
                            4: 'Модули',
                            5: 'Переменные',
                            6: 'Заказы',
                            7: 'Каталог услуг',
                            8: 'Адресы точек',
                            9: 'Промокоды',
                            10: 'Карточка',
                            11: 'Посты',
                            12: 'Переходы',
                            13: 'Статистика',
                            14: 'Инструменты',
                            15: 'Мессенджер'
                        }
                    }
                }
            }
        }
    }
}
